import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Fab, FabProps, Tooltip } from "@mui/material";
import * as React from "react";
import { useSetRecoilState } from "recoil";
import { USE_SELECTED_INDEX } from "../hooks/useSelectedElement";
import { useXoraia } from "../hooks/useXoraia";

const ShowPreview: React.FC<FabProps> = (props) => {
  const [config, setConfig] = useXoraia();
  const setSelectedIndex = useSetRecoilState(USE_SELECTED_INDEX);

  const handleClick = () => {
    setConfig((old) => ({
      ...old,
      env: old.env !== "preview" ? "preview" : "dev",
    }));

    setSelectedIndex(null);
  };

  const isPreviewing = config.env === "preview";

  return (
    <React.Fragment>
      <Tooltip
        title={
          isPreviewing
            ? "Fermer la Prévisualisation"
            : "Afficher la Prévisualisation"
        }
        placement={isPreviewing ? "top" : "bottom"}
      >
        <Fab
          size="small"
          {...props}
          sx={{
            ...props.sx,
            bottom: 20,
            left: "calc(50% - 24px)",
            zIndex: 10001,
            position: isPreviewing ? "fixed" : "static",
          }}
          onClick={handleClick}
        >
          {isPreviewing ? <VisibilityOff /> : <Visibility />}
        </Fab>
      </Tooltip>
    </React.Fragment>
  );
};

export default ShowPreview;
